import { makeStyles } from '@material-ui/core/styles'
import { ExploreCatalogCategory } from '../../core/types/explore.types'

type ExploreCatalogFiltersProps = {
  categories: ExploreCatalogCategory[]
  selectedCategory: string
  onSelectCategory: (categoryId: string) => void
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
    justifyContent: 'center',
  },
  filter: {
    borderRadius: 9999,
    padding: '8px 16px',
    fontSize: '0.8125rem',
    fontWeight: 500,
    transition: 'all 200ms ease',
    border: 0,
    cursor: 'pointer',
  },
  filterActive: {
    background: '#d73f2e', // coral-600
    color: '#fff',
  },
  filterInactive: {
    background: 'var(--ds-bg-surface, #fff)',
    color: 'var(--ds-fg-tertiary, #8c92a5)',
    border: '1px solid var(--ds-border-default, #d7dae4)',
    '&:hover': {
      color: 'var(--color-coral-sender, #E8735A)',
      borderColor: 'var(--color-coral-sender, #E8735A)',
    },
  },
}))

const ExploreCatalogFilters = ({
  categories,
  selectedCategory,
  onSelectCategory,
}: ExploreCatalogFiltersProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {categories.map((cat) => (
        <button
          key={cat.id}
          type="button"
          className={`${classes.filter} ${
            selectedCategory === cat.id ? classes.filterActive : classes.filterInactive
          }`}
          onClick={() => onSelectCategory(cat.id)}
        >
          {cat.label}
        </button>
      ))}
    </div>
  )
}

export default ExploreCatalogFilters
